<template>
  <div class="channel">
    <div class="channel_functional">
      <div class="item">
        <span class="item_title">平台</span>
        <el-select
          v-model="obj.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="clean"
          @change="alew"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <span class="item_title">渠道号</span>
        <el-autocomplete
          v-model="obj.channel_code"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">渠道名称</span>
        <el-input
          v-model="obj.channel_name"
          placeholder="请输入渠道名称"
          style="width: 220px"
        />
      </div>

      <div class="item">
        <span class="item_title">优化师</span>
        <el-input
          v-model="obj.optimizer"
          placeholder="请输入优化师"
          style="width: 220px"
        />
      </div>

      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="timesr"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-value="timeDefaultShow"
        />
      </div>
      <div class="item">
        <el-button type="primary" @click="submit">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportChannelReport"
        >导出</el-button>
        <el-button type="primary" @click="addorder">添加订单</el-button>
      </div>
    </div>
    <div class="channel_main">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        height="100%"
      >
        <el-table-column
          fixed
          prop="reg_date"
          label="注册日期"
          width="150"
          align="center"
        />
        <el-table-column
          prop="channel_code"
          label="渠道号"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <p v-if="+controlId !== +scope.row.id">{{ scope.row.channel_code }}</p>
            <el-popover
              v-else-if="scope.row.channels.split(',').length > 3"
              placement="top-start"
              title="详细内容"
              width="200"
              trigger="hover"
              :content="scope.row.channels.split(',').join('\n')"
            >
              <p slot="reference" style="white-space: break-spaces;">{{ processingDisplay(scope.row.channels) }}</p>
            </el-popover>
            <p v-else style="white-space: break-spaces;">{{ processingDisplay(scope.row.channels) }}</p>
            <span v-if="scope.row.channels.split(',').length > 1" class="control" @click="+controlId === +scope.row.id ? controlId = null : controlId = scope.row.id">{{ +controlId === +scope.row.id ? '收起' : '展开' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="channel_name"
          label="渠道名称"
          width="120"
          align="center"
        />
        <el-table-column
          prop="optimizer"
          label="优化师"
          width="120"
          align="center"
        />
        <el-table-column
          prop="new_num"
          label="新增用户"
          width="120"
          align="center"
        />
        <el-table-column
          prop="accumulative_total"
          label="累积充值"
          width="120"
          align="center"
        />
        <el-table-column prop="cost" label="成本" width="120" align="center">
          <template slot-scope="scope">
            <div class="inputBox">
              <span
                v-if=" activeItem? activeItem.id === scope.row.id? false: true: true "
              >{{ scope.row.cost }}</span>
              <input
                v-if=" activeItem? activeItem.id === scope.row.id ? true: false : false "
                v-model="itemText"
                autofocus
                class="input"
                @blur="blur"
              >
              <i
                v-if="
                  activeItem
                    ? activeItem.id === scope.row.id
                      ? false
                      : true
                    : true
                "
                class="el-icon-edit"
                @click="(activeItem = scope.row), (itemText = scope.row.cost)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="hb" label="回本率" width="120" align="center" />
        <el-table-column
          v-for="(item, index) in num"
          :key="item"
          prop=""
          width="170"
          :label="`第${index + 1}天充值`"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row" class="recharge">
              <span>{{ scope.row.data[index].zc
              }}{{ scope.row.data[index].zc !== "-" && "元" }}</span>
              <br>
              <span>回：{{ scope.row.data[index].zcb
              }}{{ scope.row.data[index].zcb !== "-" && "%" }}</span>
              <br>
              <span>增：{{ scope.row.data[index].zzl
              }}{{ scope.row.data[index].zzl !== "-" && "%" }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="channel_paging">
      <!-- <el-pagination
        layout="prev, pager, next"
        :total="total"
        @current-change="(obj.page = $event),(getList())"
      /> -->
      <pagination-right
        :total="total"
        :current-page="obj.page"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <span>{{ obj.page }}</span>
    </div>
    <el-dialog title="新增" :visible.sync="dialogVisible" width="30%">
      <addOrder
        :platformselectlistarr="platformSelectList"
        @handupdata="handupdata"
      />
    </el-dialog>
  </div>
</template>

<script>
import { /* getList, */ /* setCost, */ exportChannelReport, getList1, setCost1 } from '@/api/report/channel.js'
import { getselectlist } from '@/api/providerAccountManagement/WeChatAccountFans'
import { getchannelplatform } from '@/api/report/wechatUsers.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addOrder from '@/views/report/channelListcompent/components/addOrder.vue'
export default {
  name: 'SevenChannelReport',
  components: {
    PaginationRight,
    addOrder
  },
  data() {
    return {
      tableData: [],
      platformSelectList: [], // 渠道号筛选列表
      timesr: '',
      obj: {
        platform_id: null,
        channel_code: '',
        channel_name: '',
        optimizer: '',
        start_date: '',
        end_date: '',
        page: 1
      },
      total: null,
      loading: false,
      num: 90,
      pickerOptions: {
        disabledDate(v) {
          return (
            v.getTime() >
            new Date().getTime() - (86400000 - 24 * 60 * 60 * 1000)
          )
        }
      },
      timeDefaultShow: '',
      activeItem: null,
      itemText: null,
      dialogVisible: false,
      controlId: null
    }
  },

  created() {
    this.getpingtai()
    this.getList()
    // this.getpingtai()
    this.timeDefaultShow = new Date()
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1)
    window.This = this
  },

  methods: {
    clean() {
      this.obj.platform_id = null
      this.obj.channel_code = ''
      this.getList()
    },
    addorder() {
      this.dialogVisible = true
    },
    // 分页
    fetchPageSize(e) {
      this.obj.page_size = e
      this.getList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.getList()
    },
    async getList() {
      this.loading = true
      const data = await getList1(this.obj)
      this.tableData = data.data.list
      this.total = data.data.total
      this.num = this.getMaxLength(this.tableData)
      this.loading = false
    },
    // 获取平台数据
    getpingtai() {
      this.loading = true
      getchannelplatform().then((res) => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
    },
    getMaxLength(data = []) {
      let num = 0
      for (let i = 0; i < data.length; i++) {
        data[i].data.length > num && (num = data[i].data.length)
      }
      return num
    },

    reset() {
      this.timesr = null
      this.obj.start_date = null
      this.obj.end_date = null
      this.obj.channel_code = null
      this.obj.channel_name = null
      this.obj.optimizer = null
      this.obj.platform_id = null
      this.getList()
    },
    submit() {
      if (this.timesr) {
        this.obj.start_date = this.timesr[0]
        this.obj.end_date = this.timesr[1]
      } else if (!this.timesr) {
        this.obj.start_date = undefined
        this.obj.end_date = undefined
      }
      this.obj.page = 1
      this.getList()
    },

    // 修改成本
    async blur() {
      if (this.itemText !== this.activeItem.cost) {
        await setCost1({
          channel_code: this.activeItem.channel_code,
          date: this.activeItem.reg_date,
          cost: +this.itemText,
          platform_id: this.activeItem.platform_id
        })
        await this.getList()
      }

      this.activeItem = null
      this.itemText = null
    },
    async exportChannelReport() {
      const data = await exportChannelReport({
        channel_code: this.obj.channel_code,
        channel_name: this.obj.channel_name,
        optimizer: this.obj.optimizer,
        start_date: this.timesr.length ? this.timesr[0] : '',
        end_date: this.timesr.length ? this.timesr[1] : ''
      })
      this.$message({
        message: `导出成功，任务ID为：${data.data.task_id}`,
        type: 'success'
      })
    },
    handupdata() {
      this.getList()
      this.dialogVisible = false
    },
    querySearchAsync(queryString, callback) {
      var list = [{}]
      getselectlist({
        platform_id: this.obj.platform_id,
        keyword: this.obj.channel_code
      }).then((response) => {
        for (const i of response.data) {
          i.value = i.channel_code // 想要展示的数据 // 将想要展示的数据作为value
        }
        list = response.data
        callback(list)
      })
    },
    handleSelect(item) {
      console.log(item)
      // do something
    },
    alew() {
      this.obj.channel_code = null
    },

    processingDisplay(channels) {
      const s = channels.split(',').slice(0, 3)
      s.length > 3 && s.push('...')
      return channels.split(',').length > 3 ? s.join('\n') : channels.split(',').join('\n')
    }
  }
}
</script>

<style lang="less" scoped>
.channel {
  width: 97%;
  margin: 30px auto;
  height: 90%;
  max-height: 91%;
  border: 1px solid #c4c7ce;
  display: flex;
  flex-direction: column;

  .channel_functional {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;

    .item {
      margin: 5px 10px;
      display: flex;
      align-items: center;
      .item_title {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  .channel_main {
    flex-grow: 1;
    overflow: auto;

    .recharge {
      display: flex;
      flex-direction: column;

      span {
        font-size: 15px;
      }
    }

    .inputBox {
      display: flex;
      background-color: transparent;
      align-items: center;

      input {
        padding: 5px;
      }
      span {
      }
      i {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .channel_paging {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.control{
  cursor: pointer;
  color: #4b99da;
}

</style>
